// extracted by mini-css-extract-plugin
module.exports = {"box":"Supporters-module--box--8I616","container":"Supporters-module--container--3F09x"};